import {defineMessages} from 'react-intl';

export default defineMessages({
  FANPROTECT_TITLE: {
    id: 'common.moreInfo.trustMessage.fanProtect.title',
    defaultMessage: 'FanProtect',
  },
  FANPROTECT_INFO: {
    id: 'common.moreInfo.trustMessage.fanProtect.info',
    defaultMessage: 'Buy and sell with confidence. Every order is 100% guaranteed. {legalLink}',
  },
  FANPROTECT_LINK: {
    id: 'common.moreInfo.trustMessage.fanProtect.link',
    defaultMessage: 'Restrictions apply.',
  },
  FAN_PROTECT_WARRANTY: {
    id: 'common.moreInfo.trustMessage.fanProtect.warranty',
    defaultMessage:
      'We grant you a FanProtect warranty for the offered product. We grant you a failure warranty in addition to the statutory defect rights against the seller.',
  },
  FAN_PROTECT_WARRANTY_CLAIM: {
    id: 'common.moreInfo.trustMessage.fanProtect.warranty.claim',
    defaultMessage: 'In the event of a warranty claim, please contact us as the guarantor:',
  },
  FAN_PROTECT_WARRANTY_ADDRESS: {
    id: 'common.moreInfo.trustMessage.fanProtect.warranty.address',
    defaultMessage: 'Ticketbis S.L. Gran Vía 45, Planta 7 48011 Vizcaya (Bilbao) Spain - {email}',
  },
  FAN_PROTECT_WARRANTY_TITLE: {
    id: 'common.moreInfo.trustMessage.fanProtect.warranty.title',
    defaultMessage: 'Note',
  },
  FAN_PROTECT_WARRANTY_RIGHTS_SUMMARY: {
    id: 'common.moreInfo.trustMessage.fanProtect.warranty.rights.summary',
    defaultMessage:
      'This dealer warranty does not limit your statutory rights in the event of defects arising from the contract concluded and can be claimed by you free of charge.',
  },
  FAN_PROTECT_WARRANTY_RIGHTS: {
    id: 'common.moreInfo.trustMessage.fanProtect.warranty.rights',
    defaultMessage:
      'Consequently, any existing statutory warranty rights against us remain unaffected by this warranty promise.',
  },
  FAN_PROTECT_WARRANTY_CONTRACT_SUMMARY: {
    id: 'common.moreInfo.trustMessage.fanProtect.warranty.contract.summary',
    defaultMessage:
      'With the conclusion of the purchase contract, a contract between the buyer and the private third-party seller is concluded.',
  },
  FAN_PROTECT_WARRANTY_CONTRACT: {
    id: 'common.moreInfo.trustMessage.fanProtect.warranty.contract',
    defaultMessage:
      'StubHub International only acts as a market platform operator. Obligations to procure and deliver the purchased item arising from the conclusion of the purchase contract therefore affect the private third-party provider alone and cannot be asserted directly against StubHub International. StubHub International shall only be liable to the buyer for the obligations assumed within the scope of FanProtect.',
  },
});
